var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      visible: _vm.showVisible,
      width: 1000,
      closable: false
    }
  }, [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("保险信息")))])]), _c("div", {
    staticClass: "infoBox"
  }, _vm._l(_vm.insuranceInfo, function (item, i) {
    return _c("div", {
      key: i
    }, [_c("div", {
      staticClass: "left"
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]), _c("div", {
      staticClass: "right"
    }, [_vm._v(" " + _vm._s(_vm.$t(_vm.insuranceInfoData[item.key]) || "-") + " ")])]);
  }), 0), _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("投保信息")))])]), _c("div", {
    staticClass: "infoBox"
  }, _vm._l(_vm.insureInfo, function (item, i) {
    return _c("div", {
      key: i
    }, [_c("div", {
      staticClass: "left"
    }, [_vm._v(_vm._s(_vm.$t(item.name)))]), item.key === "policyStatus" ? _c("div", {
      staticClass: "right"
    }, [_vm._v(" " + _vm._s(_vm.$t(_vm.insureInfoData[item.key]) || "-") + " ")]) : _c("div", {
      staticClass: "right"
    }, [_vm._v(" " + _vm._s(_vm.$t(_vm.insureInfoData[item.key]) || "-") + " ")])]);
  }), 0), _vm.insuranceInfoData.policyStatus == "退保中" || _vm.insuranceInfoData.policyStatus == "已退保" ? _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("退保信息")))])]) : _vm._e(), _vm.insuranceInfoData.policyStatus == "退保中" || _vm.insuranceInfoData.policyStatus == "已退保" ? _c("div", {
    staticClass: "infoBox"
  }, _vm._l(_vm.cancellationInfo, function (item, i) {
    return _c("div", {
      key: i
    }, [_c("div", {
      staticClass: "left"
    }, [_vm._v(" " + _vm._s(_vm.insuranceInfoData.policyStatus == "退保中" && item.key == "rePremium" ? _vm.$t("应退保费") : _vm.$t(item.name)) + " ")]), _c("div", {
      staticClass: "right"
    }, [_vm._v(" " + _vm._s(_vm.cancellationInfoData[item.key] || "-") + " ")])]);
  }), 0) : _vm._e(), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: function ($event) {
        return _vm.$emit("cancel");
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("关闭")))])], 1)], 2);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };